import React, { useMemo } from "react";
import styles from "./reports.module.scss";
import Input from "components/Input";
import Table from "components/Table";
import { companyDocsColumns } from "./columns";
import { useQuery } from "@tanstack/react-query";
import { getCompanyTaxDocs, downloadCompanyTaxDoc } from "services/reports";

const mapDoc = (doc) => ({
    id: doc.id,
    jurisdiction: doc.jurisdiction || "—",
    label: doc.label || doc.documentType || doc.name || "—",
    year: doc.year || (doc.filedOn ? new Date(doc.filedOn).getFullYear() : "—"),
    field_on: doc.filedOn
        ? new Date(doc.filedOn).toLocaleDateString("en-US", { weekday: "long", year: "numeric", month: "short", day: "numeric" })
        : doc.createdAt
        ? new Date(doc.createdAt).toLocaleDateString("en-US", { weekday: "long", year: "numeric", month: "short", day: "numeric" })
        : "—",
});

const CompanyTaxDocs = () => {
    const [search, setSearch] = React.useState("");

    const { data: rawDocs, isLoading, isError } = useQuery({
        queryKey: ["companyTaxDocs"],
        queryFn: getCompanyTaxDocs,
    });

    const columns = useMemo(() => companyDocsColumns(downloadCompanyTaxDoc), []);

    const docs = Array.isArray(rawDocs) ? rawDocs : (rawDocs?.data ?? rawDocs?.items ?? []);

    const tableData = useMemo(() => {
        return docs
            .map(mapDoc)
            .filter(
                (d) =>
                    !search ||
                    d.label.toLowerCase().includes(search.toLowerCase()) ||
                    d.jurisdiction.toLowerCase().includes(search.toLowerCase())
            );
    }, [docs, search]);

    return (
        <div className={styles.companyDocsContainer}>
            <div className={styles.header}>
                <Input
                    placeholder="Search by Label or Jurisdiction"
                    style={{ minWidth: "300px" }}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>
            {isLoading ? (
                <p className="text-center mt-4 text-muted">Loading documents...</p>
            ) : isError ? (
                <p className="text-center mt-4 text-danger">Failed to load company tax documents.</p>
            ) : tableData.length === 0 ? (
                <p className="text-center mt-4 text-muted">{search ? 'No documents match your search.' : 'No company tax documents found.'}</p>
            ) : (
                <Table
                    headers={columns}
                    data={tableData}
                    containerStyle={{ border: "none", borderRadius: "0px" }}
                />
            )}
        </div>
    );
};

export default CompanyTaxDocs;
